import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import CheckBox from '../../Components/CheckBox/CheckBox'
import { FaPlusSquare } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline, MdOutlineSaveAlt } from 'react-icons/md'
import http from '../../Service/http'
import { toast } from 'react-toastify'
import { accept, OknoRoleType } from '../../store/accept'
import SearchRole from '../../block/ReactSearchRole'
import { getNameHeadStudent, getOknoStudentRole } from '../../Service/accept'
import { FcCancel } from 'react-icons/fc'
import ConfirmModal from './../../Components/Modal/ConfirmModal'

export const AcceptStudent = observer(function () {
	const { t } = useTranslation()
	const notify = (title: string) => toast.success(title)
	const [idTeacher, setIdTeacher] = useState<number>(0)
	const [addNew, setAddNew] = useState<boolean>(false)
	const [form, setForm] = useState<OknoRoleType>({
		// Buhgalteriy: false,
		// KjMTB: false,
		// biblioteka: false,
		// ckb: false,
		// dekanat: false,
		id_role_okno: 0,
		// obshejitie: false,
		// pole1: false,
		// pole2: false,
		// pole3: false,
		t_fio: ''
	})
	const [headNameList,setHeadNameList]=useState([])
	const [formType, setFormType] = useState([]);

	const [delModal, setDelModal] = useState<{
		modal: boolean
		id_docs: number
	}>({
		modal: false,
		id_docs: 0
	})

	const [disbles, setDsbles] = useState<number>(0)

	const getAllTeachers = async () => {
		const data = await getOknoStudentRole()
		accept.newOknoRoles(data)
	}

	const getAllStudentPole= async () => {
		const data = await getNameHeadStudent()
		console.log('studentge',data)
		setHeadNameList(data)
	}  
	useEffect(() => {
		getAllTeachers()
		getAllStudentPole()
		const app = document.querySelector('.LayoutPage')
		if (app) {
			app.addEventListener('click', (e: any) => {
				if (e.target) {
					const searchWrap = e.target.closest('.ContentsWrapper')
					if (!searchWrap) {
						setDsbles(0)
					}
				}
			})
		}
	}, [])
	const tdCenter = { display: 'flex', justifyContent: 'center', width: '100%' }

	return (
		<>
			<ConfirmModal
				setIsOpen={() => {
					setDelModal({
						modal: false,
						id_docs: 0
					})
				}}
				title={'Удалить'}
				isOpen={delModal.modal}
				hundleTrue={async () => {
					if (delModal.id_docs) {
						const res = await http.delete('/okno/student?id=' + delModal.id_docs)
						if (res.data.result) {
							getAllTeachers()
							notify('Успешно удалено!')
							setDelModal({
								modal: false,
								id_docs: 0
							})
						}
					}
				}}
			/>
			<div className='TableWrapper'>
				<table className='accept_table'>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							{headNameList?.length && headNameList?.map((pole:any)=><th style={{ width: '5%' }}>{pole.okno_title}</th>
							)}
							<th style={{ width: '5%' }}>
								<FaPlusSquare
									style={{ fontSize: 18 }}
									onClick={() => {
										setAddNew(!addNew)
										setDsbles(0)
									}}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{addNew ? (
							<tr style={{ backgroundColor: 'rgb(160 202 223)', height: '52' }}>
								<td>{0}</td>
								<td style={{ textAlign: 'left' }}>
									<SearchRole
										style={{ borderRadius: '6px' }}
										changeIdStud={(param: number) => {
											setIdTeacher(param)
										}}
									/>
								</td>
								{headNameList.map((obj:any, colIndex) => (
                <td>
				  <CheckBox
   					 onchange={(e: any) => {   					     
					setFormType((state: any) => {
						console.log('checked',{[obj.okno_pole] : e})
						console.log('form',formType)
   					         return { ...state, [obj.okno_pole] : e };
   					     });
   					 }}
   					 styles={tdCenter}
					//  checked={formType && formType[obj.okno_pole]===true ? true :false}
					checked={Boolean(formType && formType[obj.okno_pole])}
					
				     active={true}
   					 dsbl={false}
   					 item={formType}
/>

            </td>
		   ))
				}
								<td>
									<div className='edit'>
										{
											<MdOutlineSaveAlt
												title={t('st:button.save')}
												onClick={async () => {
													const res = await http.post('/okno/student', { ...formType, id_teacher: idTeacher })
													setAddNew(!addNew)
													if (res.data.result) {
														console.log("getOknoStudentRole", res.data.result)
														const data = await getOknoStudentRole()
														getAllTeachers()
														accept.newOknoRoles(data)
														notify(t('st:other.saved'))
														setFormType([])

													}
												}}
											/>
										}
									</div>
								</td>
							</tr>
						) : (
							''
						)}
						{accept.oknoRole?.map((item: any, index: number) => {
							let dsbl = true
							if (disbles == item.id_role_okno) {
								return (
									<tr key={index} style={{ backgroundColor: 'rgb(160 202 223)', height: dsbl ? '' : '52' }}>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.t_fio}</td>

										{headNameList.map((obj:any, colIndex) => (
                <td>
				  <CheckBox
   					 onchange={(e: any) => {   					     
					setFormType((state: any) => {
						console.log('checked',{[obj.okno_pole] : e})
						console.log('form',formType)
   					         return { ...state, [obj.okno_pole] : e };
   					     });
   					 }}
   					 styles={tdCenter}
					//  checked={formType && formType[obj.okno_pole]===true ? true :false}
					checked={Boolean(formType && formType[obj.okno_pole])}
				     active={true}
   					 dsbl={false}
   					 item={item}
/>

            </td>
		   ))
				}
										<td>
											<div className='edit'>
												{
													<MdOutlineSaveAlt
														title={t('st:button.save')}
														onClick={async () => {
															const res = await http.put('/okno/student', {
																...formType,
																id_role_okno:form.id_role_okno
															})
															if (res.data.result) {
																const data = await getOknoStudentRole()
																getAllTeachers()
																accept.newOknoRoles(data)
																notify(t('st:other.saved'))
																setDsbles(0)
																setFormType([])
															}
														}}
													/>
												}
												<FcCancel
													onClick={() => {
														setDsbles(0)
													}}
												/>
											</div>
										</td>
									</tr>
								)
							}
							return (
								<tr
									key={index}
									style={{ backgroundColor: dsbl ? '' : 'rgb(160 202 223)', height: dsbl ? '' : '52' }}
									onClick={() => {
										setDsbles(0)
										setAddNew(false)
									}}
								>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
									{ headNameList.map((obj:any, colIndex) => (
                <td>
				
<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item[obj.okno_pole]}
											active={true}
											dsbl={dsbl}
											item={item}
										/>

            </td>
		   ))
				}
									<td>
										<div className='edit'>
											{
												<FiEdit
													onClick={(e: any) => {
														e.stopPropagation()
														setDsbles(item.id_role_okno)
														setForm(item)
														setFormType(item)
														setAddNew(false)
													}}
												/>
											}
											<MdDeleteOutline
												style={{ zIndex: 1222 }}
												onClick={() => {
													setDelModal({
														modal: true,
														id_docs: item.id_role_okno
													})
												}}
											/>
										</div>
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
})
